/*DAY OFF REPORT*/

var today = new Date();

Vue.component('dayoffreport', {
    template:'#dayoffreport-template',

    data:function(){
        return{
            list: [],
            searchString:'',
            modal:'',
            date_start:today.getFullYear()+'-01-01',
            date_end:today.getFullYear()+'-12-31',
            users:[],
            active_user_id:-1,
            active_division:-1,
            divisions: []
        }
    },
    created:function(){
        activeInstance = this;

        this.getDivisions();
        //activeInstance.modal = $('body').find('#create_user_modal').html();
        showLoadingOverlay();
        axios.post(baseURL+'/api/statistics/users/off_time_report', {
            date_start:activeInstance.date_start,
            date_end:activeInstance.date_end,
            user_id:activeInstance.active_user_id
        }).then(function(response){
            $('body').LoadingOverlay("hide");
            activeInstance.list=response.data;
            setTimeout(function() {

                var $table = $('.fixed_header_table');
                $table.floatThead({
                    top:70
                });

                setTimeout(function(){
                    $(function () {
                        $('#datetimepicker_start').datetimepicker({
                            format: 'YYYY-MM-DD',
                            locale: 'hu'
                        });
                        $("#datetimepicker_start").on("dp.change", function (e) {
                            activeInstance.fetchRecords();
                        });
                        $('#datetimepicker_end').datetimepicker({
                            format: 'YYYY-MM-DD',
                            locale: 'hu'
                        });
                        $("#datetimepicker_end").on("dp.change", function (e) {
                            activeInstance.fetchRecords();
                        });


                        //var running_footable = FooTable.get(".responsive-table");
                        //if (running_footable) {
                        //   running_footable.destroy();
                        //}

                        //$('.responsive-table').footable();
                    });
                },300);
            },200);
        });
    },
    methods:{
        getDivisions: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/company_divisions')
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    activeInstance.divisions = response.data;
                    activeInstance.active_division = -1;
                    activeInstance.extractUsers();
                })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
        },
        extractUsers:function(){

            axios.get(baseURL+'/statistics/users/off_time')
                .then(function(response){
                    activeInstance.users = response.data;
                    activeInstance.fetchRecords();
                })
                .catch(function(error){
                    console.log(error);
                });
        },
        exportRecords:function(){
            setTimeout(function(){
                showLoadingOverlay();
                axios.post(baseURL+'/api/export/users/off_time_report',{
                    date_start:activeInstance.date_start,
                    date_end:activeInstance.date_end,
                    user_id:activeInstance.active_user_id,
                    division_id:activeInstance.active_division
                }).then(function(response){
                    $('body').LoadingOverlay("hide");
                    console.log(response);
                    location.href=response.data;
                });
            },200);

        },
        fetchRecords:function(){
            setTimeout(function(){
                showLoadingOverlay();
                axios.post(baseURL+'/api/statistics/users/off_time_report',{
                    date_start:activeInstance.date_start,
                    date_end:activeInstance.date_end,
                    user_id:activeInstance.active_user_id,
                    division_id:activeInstance.active_division
                }).then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.list=response.data;
                });
            },200);

        },
        humanize:function(text){
            switch (text) {
                case 'day_off':
                    return 'Szabadság';
                    break;
                case 'sick_leave':
                    return 'Betegszabadság';
                    break;
                case 'unconfirmed':
                    return 'Elbírálás alatt';
                    break;
                case 'confirmed':
                    return 'Jóváhagyott';
                    break;
                case 'rejected':
                    return 'Elutasított';
                    break;
                default:
                    break;
            }
        }

    }
});
